// Shared sort + search helpers for admin tables.
//
// Keeps the logic in one place so the Downloads table and the Messages
// list behave identically (case-insensitive OR match across configured
// fields; stable sort by direction).

/**
 * Case-insensitive substring filter across the given `fields`.
 * Empty query returns `items` unchanged (reference-stable).
 */
export function searchItems(items, query, fields) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return items;
  return items.filter((item) =>
    fields.some((f) => {
      const v = item?.[f];
      return v != null && String(v).toLowerCase().includes(q);
    })
  );
}

/**
 * Returns a new array sorted by `sortConfig.field` in `sortConfig.direction`.
 * Null / undefined values always sink to the bottom. Dates are detected by
 * ISO-string prefix; numbers compared numerically; everything else as
 * lowercase strings.
 */
export function sortItems(items, sortConfig) {
  if (!sortConfig?.field) return items;
  const { field, direction } = sortConfig;
  const mul = direction === "desc" ? -1 : 1;

  const asComparable = (v) => {
    if (v == null || v === "") return null;
    if (typeof v === "number") return v;
    if (typeof v === "string") {
      // ISO date detection — "2024-01-05T…" or "2024-01-05"
      if (/^\d{4}-\d{2}-\d{2}/.test(v)) {
        const t = Date.parse(v);
        if (!Number.isNaN(t)) return t;
      }
      return v.toLowerCase();
    }
    return v;
  };

  return [...items].sort((a, b) => {
    const av = asComparable(a?.[field]);
    const bv = asComparable(b?.[field]);
    if (av == null && bv == null) return 0;
    if (av == null) return 1; // nulls always last
    if (bv == null) return -1;
    if (av < bv) return -1 * mul;
    if (av > bv) return 1 * mul;
    return 0;
  });
}
